module.exports = __webpack_public_path__ + "img/en.7035bb4e.svg";